import * as React from "react";
import '../permissions.scss';

var ListUsers = function ListUsers(props) {
  var activeUser = props.activeUser,
      setActiveUser = props.setActiveUser,
      users = props.users;
  return /*#__PURE__*/React.createElement("div", {
    className: "card cntUsers"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("b", null, "Ejecutivos"))), /*#__PURE__*/React.createElement("div", {
    className: "card-body list-group"
  }, users.map(function (user) {
    return /*#__PURE__*/React.createElement("a", {
      key: user.id,
      href: "#",
      className: "list-group-item ".concat((user === null || user === void 0 ? void 0 : user.id) === (activeUser === null || activeUser === void 0 ? void 0 : activeUser.id) ? "active" : ""),
      onClick: function onClick() {
        return setActiveUser(user);
      }
    }, user.email);
  })));
};

export default ListUsers;